import React, { useState, useEffect, useReducer } from 'react';
import SchoolInput from './SchoolInput';

const ResponseMeta = (props) => {
    return (
            <React.Fragment>
            <div className="row">
                <div className="rowItem"><label htmlFor="haveUsedBefore">Have you used the DUC Tool before? {props.errors.indexOf("haveUsedBefore") > -1 ? <span className="error">*</span> : <React.Fragment />} </label> </div>
                    <div className="rowItem">
                    <select name="haveUsedBefore" value={props.haveUsedBefore} onChange={(e) => props.updateField('haveUsedBefore', e.target.value)}>
                            <option value="0" disabled>Choose one</option>
                            <option value="1">No</option>
                            <option value="2">Yes, for the same subject</option>
                            <option value="3">Yes, for a different subject</option>                
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="rowItem">
                    <label htmlFor="use">Please select the statement most relevant to your use of the DUC Tool {props.errors.indexOf("use") > -1 ? <span className="error">*</span> : <React.Fragment />}</label>
                    </div>
                    <div className="rowItem">
                    <select name="use" value={props.use} onChange={(e) => props.updateField('use', e.target.value)}>
                        <option value="" disabled>Choose one</option>
                        <option value="independently">I am using this tool to reflect on my subject site (independently)</option>
                        <option value="as part of an LTC consultation">I am using this tool to reflect on my subject site (as part of an LTC consultation)</option>          
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="rowItem">
                    <label htmlFor="entity">Which entity are you from? {props.errors.indexOf("entity") > -1 ? <span className="error">*</span> : <React.Fragment />}</label> </div>
                <div className="rowItem">
                    <select name="entity" value={props.entity} onChange={(e) => props.updateField('entity', e.target.value)}>
                            <option value="" disabled>Choose one</option>
                        {props.entities ? props.entities.map((e, i) => <option key={e.entityID} value={e.entityText}>{e.entityText}</option>) : <option />}
                        </select>
            
                    </div>
                </div>
                {props.entity ?
                    <React.Fragment>
                        {props.entity.includes("UOW Wollongong") ?
                            <React.Fragment>
                            <div className="row">Which school is responsible for this subject?{props.errors.indexOf("unit") > -1 ? <span className="error">*</span> : <React.Fragment />}</div>
                            <div className="row"><em>This information will help LTC identify usage of the tool and inform support offerings at a school level.</em></div>
                            <SchoolInput defaultFaculty={props.faculty} defaultSchool={props.unit} handleFacultyChange={(value) => props.updateField('faculty', value)} handleSchoolChange={(value) => props.updateField('unit', value)} schools={props.schools} />
                            </React.Fragment> :
                            <React.Fragment>
                                <div className="row">
                                <div className="rowItem"><label htmlFor="unit">Which unit are you from?{props.errors.indexOf("unit") > -1 ? <span className="error">*</span> : <React.Fragment />}</label>
                                    </div>
                                    <div className="rowItem">
                                    <input type="text" name="unit" value={props.unit} onChange={(e) => props.updateField('unit', e.target.value)} autoFocus />
                                    </div>
                                    </div> </React.Fragment>}
                 </React.Fragment>
                : <React.Fragment />
                }                
            </React.Fragment>
        )
}
export default ResponseMeta;